import React, { useState, useCallback, useEffect } from "react";

import SalesFilter from "../../common_component/salesFilter";
import { getInitialDate } from "../../../../helper/formatDate";
import { useNavigate } from "react-router-dom";
import { Constant } from "../../../../helper/constant";
import SalesYearly from "../../common_component/salesYearly";
import SalesSummaryYearly from "../../common_component/salesSummaryYearly";

const PharmacySalesYearly = () => {
  // =====================
  // Constant Definition
  // =====================

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [transactionData, setTransactionData] = useState([]);
  const [summaryTransaction, setSummaryTransaction] = useState(null);
  const [filterData, setFilterData] = useState(null);

  // ==========================
  // Network Request Definition
  // ==========================

  const getInitialTransaction = useCallback(async () => {
    try {
      setIsLoading(true);

      let url;
      if (filterData == null) {
        const params = new URLSearchParams({
          date: getInitialDate("yearly"),
        }).toString();

        url = `${Constant.BASE_API_URL}/produk-transaksi/yearly?${params}`;
      } else {
        const params = new URLSearchParams({
          date: filterData.date,
          shift: filterData.shift.index || "",
        }).toString();

        url = `${Constant.BASE_API_URL}/produk-transaksi/yearly?${params}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + localStorage.getItem("token"),
        },
      });

      if (!response.ok) {
        alert("Gagal Menerima Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }

      const json = await response.json();
      const data = json.data;

      if (!data.transaction) {
        setTransactionData([]);
      } else {
        setTransactionData(data.transaction);
        setSummaryTransaction(data.summary);
      }
    } catch (error) {
      setTransactionData([]);
      setSummaryTransaction(null);
    } finally {
      setIsLoading(false);
    }
  }, [navigate, filterData]);

  // =====================
  // Hook Definition
  // =====================

  useEffect(() => {
    getInitialTransaction();
  }, [getInitialTransaction]);

  return isLoading ? (
    <div className="loading-container">
      <div className="loader"></div>
      <p>Sedang Memuat Mohon Menunggu</p>
    </div>
  ) : (
    <div>
      <h1>Penjualan Tahunan</h1>
      <SalesFilter
        typeOfSales={"yearly"}
        setFilterData={setFilterData}
        hideDoctorFilter
      />
      <SalesYearly
        transactionDate={getInitialDate("yearly")}
        transactionData={transactionData}
      />
      {summaryTransaction ? (
        <SalesSummaryYearly summaryData={summaryTransaction} />
      ) : (
        <p>Loading summary...</p>
      )}
    </div>
  );
};

export default PharmacySalesYearly;
